import request, { BASE_URL } from './request'

export interface AddReferralsArgs {
  referral_code: string
  new_customer_id: string
}

export const addReferrals = async (
  args: AddReferralsArgs
): Promise<{ success: boolean }> =>
  request({
    method: 'POST',
    url: `${BASE_URL}/customers/referrals`,
    data: args,
  })
